/**
 * season Normalizr Schema
 */

import { schema } from 'normalizr';

const season = new schema.Entity('seasons');

export default season;
